function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_49",
  "data-name": "Group 49"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_34",
  "data-name": "Group 34",
  transform: "translate(3.375 3.377)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  "data-name": "Group 33"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M15.225,11.727V7.273a1.689,1.689,0,0,0-2.309-1.552,1.693,1.693,0,0,0-2.25-1.113,1.692,1.692,0,0,0-3.256,0A1.69,1.69,0,0,0,5.1,6.16V7.273h0A2.771,2.771,0,0,0,3.975,9.5v2.227a3.9,3.9,0,0,0,2.25,3.521v.508A1.674,1.674,0,0,0,5.1,17.33v1.113A.56.56,0,0,0,5.663,19h7.875a.56.56,0,0,0,.563-.557V17.33a1.674,1.674,0,0,0-1.125-1.574v-.508A3.9,3.9,0,0,0,15.225,11.727Zm-2.25-4.453a.563.563,0,0,1,1.125,0V8.387a.56.56,0,0,1-.562.557h0a.56.56,0,0,1-.562-.557ZM10.725,6.16a.563.563,0,0,1,1.125,0V8.387a.56.56,0,0,1-.562.557h0a.56.56,0,0,1-.562-.557ZM8.475,5.047a.563.563,0,0,1,1.125,0V6.813a1.7,1.7,0,0,0-.562-.1H8.475ZM6.225,6.16a.563.563,0,0,1,1.125,0v.557H6.788a2.843,2.843,0,0,0-.562.056Zm6.75,11.727H6.225V17.33a.56.56,0,0,1,.563-.557h5.625a.56.56,0,0,1,.563.557Zm-.75-3.535a.557.557,0,0,0-.375.525v.784H7.35v-.784a.557.557,0,0,0-.375-.525A2.79,2.79,0,0,1,5.1,11.727V9.5A1.681,1.681,0,0,1,6.788,7.83h2.25a.557.557,0,1,1,0,1.113H6.788a.557.557,0,1,0,0,1.113A2.8,2.8,0,0,1,9.6,12.84a.563.563,0,0,0,1.125,0A3.868,3.868,0,0,0,9.479,10a1.7,1.7,0,0,0,.683-.369,1.7,1.7,0,0,0,2.25,0,1.7,1.7,0,0,0,1.687.331v1.766A2.79,2.79,0,0,1,12.225,14.352Z",
  transform: "translate(-3.975 -3.377)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_36",
  "data-name": "Group 36",
  transform: "translate(9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35",
  "data-name": "Group 35"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M10.163,0A.56.56,0,0,0,9.6.557V2.264a.563.563,0,0,0,1.125,0V.557A.56.56,0,0,0,10.163,0Z",
  transform: "translate(-9.6)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(12.375 1.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M15.06,1.313a.567.567,0,0,0-.8,0L13.14,2.427a.553.553,0,0,0,0,.787.567.567,0,0,0,.8,0L15.06,2.1A.553.553,0,0,0,15.06,1.313Z",
  transform: "translate(-12.975 -1.15)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(15.75 7.83)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M18.038,7.83H16.913a.557.557,0,1,0,0,1.113h1.125a.557.557,0,1,0,0-1.113Z",
  transform: "translate(-16.35 -7.83)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_42",
  "data-name": "Group 42",
  transform: "translate(0 7.83)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M2.288,7.83H1.163a.557.557,0,1,0,0,1.113H2.288a.557.557,0,1,0,0-1.113Z",
  transform: "translate(-0.6 -7.83)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_44",
  "data-name": "Group 44",
  transform: "translate(4.5 1.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_43",
  "data-name": "Group 43"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M7.185,2.427,6.06,1.313a.567.567,0,0,0-.8,0,.553.553,0,0,0,0,.787L6.39,3.214a.567.567,0,0,0,.8,0A.552.552,0,0,0,7.185,2.427Z",
  transform: "translate(-5.1 -1.15)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(1.125 3.377)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_45",
  "data-name": "Group 45"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M3.664,3.992,2.539,3.436a.565.565,0,0,0-.755.249.554.554,0,0,0,.252.747l1.125.557a.565.565,0,0,0,.755-.249A.554.554,0,0,0,3.664,3.992Z",
  transform: "translate(-1.725 -3.377)",
  fill: "#10151b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48",
  transform: "translate(14.625 3.377)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M17.416,3.685a.565.565,0,0,0-.755-.249l-1.125.557a.554.554,0,0,0-.252.747.565.565,0,0,0,.755.249l1.125-.557A.554.554,0,0,0,17.416,3.685Z",
  transform: "translate(-15.225 -3.377)",
  fill: "#10151b"
}))));

var SvgExpert = function SvgExpert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "motivational",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expert.1857c98b.svg";
export { ForwardRef as ReactComponent };